<template>
  <div>
    <CommonBreadCrumbs :data="breadcrumbs" />
    <div>
      <div
        :class="{
          'mt-16 md:mt-0': !selectedSectionSlug,
        }"
      >
        <div class="mb-20">
          <NuxtLayout
            name="center"
            :class="{
              'opacity-0 pointer-events-none': selectedSectionSlug,
            }"
          >
            <h1 class="md:flex mb-8 justify-center text-2xl font-bold md:text-4xl">
              {{ $t("getStarted.howWeCanHelp") }}
            </h1>
          </NuxtLayout>

          <NuxtLayout name="center" :mobilePadding="false">
            <div class="flex gap-2">
              <CommonHelpYou is-get-started />
            </div>
          </NuxtLayout>
        </div>

        <div class="bg-secondary-lighter">
          <NuxtLayout name="center" class="md:pt-20 pt-10 pb-16">
            <CommonHowItWorks :display-find-clinic-button="true" />
          </NuxtLayout>
        </div>

        <NuxtLayout name="center" class="md:pt-8">
          <CommonLiveChatBlock class="my-24"></CommonLiveChatBlock>
        </NuxtLayout>
        <!-- <ClinicCTABlock
					imgSrc="USPs_graphic_03_1"
					:getStarted="true"></ClinicCTABlock> -->
        <ClinicCTABlock class="mb-0 !h-auto"></ClinicCTABlock>
      </div>
    </div>
  </div>
</template>

<script setup>
const route = useRoute();

const selectedSectionSlug = computed(() => route.params.section);

const ALLOWED_SECTIONS = ["sexual-health", "health-and-wellness", "consultation"];
if (selectedSectionSlug.value && !ALLOWED_SECTIONS.includes(selectedSectionSlug.value)) {
  throw createError({
    statusCode: 404,
    statusMessage: "Page Not Found",
  });
}

const productStore = useProductStore();
const filterOptions = await useFilterOptions();
productStore.setFilterOptions(filterOptions);

onBeforeRouteLeave(() => {
  productStore.clearAllFilters();
});

const breadcrumbs = getBreadcrumbs("get-started");

const { data: pageData } = await useGetStartedDetail();

useMetaTitles(pageData.value.data, "get-started");

definePageMeta({
  key: "get-started-flows",
  pageTransition: false,
  layoutTransition: false,
});
</script>
